import {
  Client as HttpClient,
  type ClientOptions as HttpClientOptions
} from '@microsoft/teams.common';

import { ApiClientSettings, mergeApiClientSettings } from '../api-client-settings';

import { BotSignInClient } from './sign-in';

/**
 * @deprecated The bot client is deprecated and will be removed in a future release.
 */
export class BotClient {
  readonly signIn: BotSignInClient;

  get http() {
    return this._http;
  }
  set http(v) {
    this.signIn.http = v;
    this._http = v;
  }
  protected _http: HttpClient;
  protected _clientSettings: Partial<ApiClientSettings>;

  constructor(options?: HttpClient | HttpClientOptions, clientSettings?: Partial<ApiClientSettings>) {
    if (!options) {
      this._http = new HttpClient();
    } else if ('request' in options) {
      this._http = options;
    } else {
      this._http = new HttpClient(options);
    }

    this._clientSettings = mergeApiClientSettings(clientSettings);
    this.signIn = new BotSignInClient(this.http, this._clientSettings);
  }
}

export * from './sign-in';
